module.exports = __webpack_public_path__ + "img/americanexpress.2160ad54.svg";